export default "__VITE_ASSET__knuA6Hyk__"